import { useState, useEffect } from "react";
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from "@/components/ui/tooltip";
import { Button } from "@/components/ui/button";
import { ArrowDown } from "lucide-react";

interface OnboardingTutorialTooltipProps {
  isVisible: boolean;
  onDismiss: () => void;
}

export const OnboardingTutorialTooltip = ({ isVisible, onDismiss }: OnboardingTutorialTooltipProps) => {
  const [open, setOpen] = useState(isVisible);
  
  useEffect(() => {
    setOpen(isVisible);
  }, [isVisible]);

  const handleDismiss = () => {
    setOpen(false);
    onDismiss();
  };

  if (!isVisible) return null;

  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger asChild>
          <div className="absolute right-0 top-0 opacity-0 pointer-events-none">Trigger</div>
        </TooltipTrigger>
        <TooltipContent 
          side="bottom" 
          align="end"
          className="bg-white p-4 shadow-lg border border-gebeya-purple/20 max-w-[300px] rounded-lg animate-bounce-gentle"
          sideOffset={20}
        >
          <div className="space-y-3">
            <div className="flex items-center gap-2">
              <ArrowDown className="h-5 w-5 text-gebeya-pink animate-pulse" />
              <h4 className="font-semibold text-gebeya-purple">Edit Your Services</h4>
            </div>
            <p className="text-sm text-gray-600">
              We've created services for you! Click the <span className="font-medium">Edit</span> button to personalize them with your own details and images.
            </p>
            <Button 
              onClick={handleDismiss} 
              className="w-full bg-gradient-to-r from-gebeya-pink to-gebeya-orange text-white"
              size="sm"
            >
              Got it!
            </Button>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}; 